module.exports = __webpack_public_path__ + "statics/img/orange.5f670448.png";